'use strict';

import { createConnector } from 'react-instantsearch-dom';
import { buildCourseStatusFilter, CourseStatus, getUserCourses } from './course-status';

const applyStatus = (search_state, status) => {
	const { course_status: _course_status, ...rest } = search_state;
	
	return CourseStatus.All === status
		? { ...rest, page: 1 }
		: { ...rest, course_status: status, page: 1 };
};

/**
 * react-instantsearch v6 doesn't provide a structured contract for these
 * connector methods. See the built-in connectors for methods and parameters.
 *
 * @see connectHierarchicalMenu
 * @see connectPagination
 * @see connectRefinementList
 * @see connectToggleRefinement
 */
export const connector = {
	displayName: 'CourseStatus',
	
	getProvidedProps(props, search_state) {
		const { completed_ids, in_progress_ids } = getUserCourses();
		
		return {
			current_refinement: search_state.course_status,
			has_in_progress: in_progress_ids.length > 0,
			has_completed: completed_ids.length > 0,
		};
	},
	
	refine(props, search_state, status) {
		return applyStatus(search_state, status);
	},
	
	cleanUp(props, search_state) {
		const { course_status: _course_status, ...rest } = search_state;
		
		return rest;
	},
	
	getSearchParameters(search_parameters, props, search_state) {
		const filters = buildCourseStatusFilter(search_state.course_status);
		
		return filters
			? search_parameters.setQueryParameter('filters', filters)
			: search_parameters;
	},
	
	getMetadata(props, search_state) {
		const status = search_state.course_status;
		
		return {
			id: 'course_status',
			items: status ? [
				{
					attribute: 'course_status',
					label: status,
					currentRefinement: status,
					value: (search_state) => applyStatus(search_state, CourseStatus.All),
				}
			] : [],
		};
	},
};

export default createConnector(connector);
